module.exports = __webpack_public_path__ + "static/media/ovasen.75c66464.mp3";